import { Icon } from './types';

export const List = ({ svgProps, pathProps }: Icon) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="list"
    {...svgProps}
  >
    <path
      d="M22.6667 11.3333H39.6667V17H22.6667V11.3333ZM22.6667 22.6667H39.6667V28.3333H22.6667V22.6667ZM22.6667 34H39.6667V39.6667H22.6667V34ZM11.3333 11.3333H17V17H11.3333V11.3333ZM11.3333 22.6667H17V28.3333H11.3333V22.6667ZM11.3333 34H17V39.6667H11.3333V34ZM0 0V51H51V0H0ZM45.3333 45.3333H5.66667V5.66667H45.3333V45.3333Z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
